import { render } from "./BrowseCategories.vue?vue&type=template&id=0bd7d4a2&scoped=true&ts=true"
import script from "./BrowseCategories.ts?vue&type=script&lang=ts"
export * from "./BrowseCategories.ts?vue&type=script&lang=ts"

import "./BrowseCategories.vue?vue&type=style&index=0&id=0bd7d4a2&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd7d4a2"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QTable,QTr,QTd});
